<template>
  <div class="pointer" :class="{ course: isCourse }">
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col v-if="props.showImg" size="auto" class="ion-margin-end">
          <AppImg
            :img-src="isCourse ? courseData?.media[0]?.url : banner"
            img-alt="banner"
            class="img-wrap"
            border-radius="10px"
          />
        </ion-col>
        <ion-col>
          <div
            class="is-flex ion-align-items-center h-100 pr-2"
            :class="{ divider: showDivider }"
          >
            <p v-if="isCourse" class="fw-500">
              {{ props.courseData.course_title }}
            </p>
            <p v-else class="fw-500">
              {{ props.podcastData.title || props.podcastData.stream_title }}
            </p>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</template>

<script setup>
import {
  CATEGORY_GENERAL_MEDIA,
  CATEGORY_BANNER_MEDIA,
  CATEGORY_STREAM_STILL,
  CATEGORY_PODCAST_IMG,
} from '@/config/constants';

const PRIOR_IMAGES = [
  CATEGORY_PODCAST_IMG,
  CATEGORY_STREAM_STILL,
  CATEGORY_BANNER_MEDIA,
  CATEGORY_GENERAL_MEDIA,
];

import { IonGrid, IonCol, IonRow } from '@ionic/vue';

import { computed } from 'vue';

import { getSmallestSizeImage } from '@/helpers/functions';
import AppImg from '@/components/common/AppImg.vue';

const props = defineProps({
  podcastData: {
    type: Object,
    default: () => ({}),
  },
  courseMedia: {
    type: Array,
    default: () => [],
  },
  showImg: {
    type: Boolean,
    default: true,
  },
  showDivider: {
    type: Boolean,
    default: false,
  },
  isCourse: {
    type: Boolean,
    default: false,
  },
  courseData: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['update:favorites']);

const banner = computed(() => {
  const validStreamImages =
    props.podcastData.media?.filter((media) =>
      PRIOR_IMAGES.includes(media.category),
    ) || [];
  validStreamImages.sort((a, b) => b.category - a.category);
  const streamImg = getSmallestSizeImage(validStreamImages)?.url ?? null;
  const courseImg = getSmallestSizeImage(props.courseMedia)?.url ?? null;
  return streamImg || courseImg;
});
</script>

<style scoped lang="scss">
@use '@/theme/custom' as *;

.img-wrap {
  height: 100px;
  width: 100px;

  &:deep(img) {
    width: 100%;
    height: 100%;
  }
}

p {
  font-size: 18px;
  line-height: 1.5rem;

  @media (max-width: $tablet-breakpoint) {
    font-size: 14px;
  }
}

.divider {
  padding: 10px 0;
  border-bottom: solid 1px white;
}

.course {
  width: 200px;
  max-width: calc((100% / 2) - 10px);
  background-color: #1e1e1e;
  border-radius: 10px;
  .img-wrap {
    height: 60px;
    width: 60px;
  }
  p {
    font-size: 12px;
    line-height: normal;
  }
}
</style>
